import React, { useState } from "react";
import ReactEcharts from "echarts-for-react";


const LineChart = (props) => {


  const symbol = props.symbol || ''; const decimals = props.decimals ?? 0;

  const formatNumber = (value) => { const number = Number(value); if (Number.isNaN(number)) { return ''; } return new Intl.NumberFormat('es-CO', { minimumFractionDigits: decimals, maximumFractionDigits: decimals, }).format(number) + symbol; };

  //const chartData = (props.data || []).map((value) => { const number = Number(value); return Number.isNaN(number) ? 0 : number; });


  const getOptions = () => ({

    xAxis: {
      type: 'category',
      boundaryGap: false
      ,
      axisLabel: {
        rotate: 30,
        interval: 0,
        textStyle: {
          fontSize: 12,
          color: '#333',
        }
      }
    },
    yAxis: {
      type: 'value',
      boundaryGap: [0, '30%']
    },
    title: {
      text: props.title,
      subtext: props.subTitle,
      left: 'center'
    },
    tooltip: {
      trigger: 'item'
    },
    legend: {
      left: 'center',
      top: 'bottom'
    },
    series: [
      {
        name: props.seriesTitle,
        type: 'line',
        smooth: true,
        yAxisIndex: 0,
        data: props.data,
        label: {
          show: props.showSerieValue,
          position: 'top',
          formatter: (params) => { return formatNumber(params.value[1]); }
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  });
  return (
    <div className="">
      <ReactEcharts
        ref={props.chartRef}
        option={getOptions()}
        style={{ height: 300 }}
      />
    </div>
  );
}


export default LineChart
